const _ = require('./status/enum');

module.exports = [_.REFUND_DECLINED, _.REFUND_REQUEST_FAILED, _.REFUND_REQUESTED, _.REFUND_SUCCESSFUL];
